import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=31e62cf3&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=31e62cf3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e62cf3",
  null
  
)

export default component.exports